// extracted by mini-css-extract-plugin
module.exports = {"intro":"T_cq","text":"T_l","particles":"T_cr"};